import { render, staticRenderFns } from "./comp_AppBar-Bottom.vue?vue&type=template&id=74564ccb&scoped=true"
import script from "./comp_AppBar-Bottom.vue?vue&type=script&lang=js"
export * from "./comp_AppBar-Bottom.vue?vue&type=script&lang=js"
import style0 from "./comp_AppBar-Bottom.vue?vue&type=style&index=0&id=74564ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74564ccb",
  null
  
)

export default component.exports